const nav = {
    'nav.dashboard': 'Dashboard',
    'nav.profiles': 'Profile',

    'nav.profile': 'Mein Profil',

    'nav.ghost.return_to_reseller': 'Zurück zum Wiederverkäufer',
    'nav.ghost.return_to_admin': 'Zurück zum Administrator',

    'nav.footer.about': 'Uber Speedcon B.V.',
    'nav.footer.conditions': 'Bedingungen',
    'nav.footer.help': 'Help',
    'nav.footer.contact': 'Kontakt',
    'nav.footer.logged_in': 'Sie sind jetzt angemeldet als',
};

export default nav;
